import { a11yAria } from '../../../TypeScript/Utilities/AriaUtilities';
import { SubNavigationHandler } from './NavigationSubtrigger';
var handleOpenNavigation = function (navigation, openTrigger, closeTrigger, backgroundWrap, searchTrigger) {
    navigation.classList.remove('hidden');
    openTrigger.classList.add('hidden');
    closeTrigger.classList.remove('hidden');
    closeTrigger.setAttribute('aria-expanded', a11yAria.toggle.expanded(closeTrigger));
    openTrigger.setAttribute('aria-expanded', a11yAria.toggle.expanded(openTrigger));
    searchTrigger.setAttribute('aria-label', a11yAria.toggle.label(searchTrigger, "Suche einblenden", "Suche ausblenden"));
    backgroundWrap.style.height = '100vh';
    document.querySelector('body').style.maxHeight = '100vh';
    document.querySelector('body').style.overflowY = 'hidden';
    document.querySelector('body').style.overflowX = 'hidden';
};
var handleCloseNavigation = function (navigation, openTrigger, closeTrigger, backgroundWrap, searchTrigger) {
    navigation.classList.add('hidden');
    openTrigger.classList.remove('hidden');
    closeTrigger.classList.add('hidden');
    closeTrigger.setAttribute('aria-expanded', a11yAria.toggle.expanded(closeTrigger));
    openTrigger.setAttribute('aria-expanded', a11yAria.toggle.expanded(openTrigger));
    searchTrigger.setAttribute('aria-label', a11yAria.toggle.label(searchTrigger, "Suche ausblenden", "Suche einblenden"));
    backgroundWrap.style.height = 'auto';
    document.querySelector('body').style.maxHeight = 'auto';
    document.querySelector('body').style.overflowY = 'auto';
    document.querySelector('body').style.overflowX = 'hidden';
};
var toggleNavigationEvent = function (_a) {
    var openTrigger = _a.openTrigger, closeTrigger = _a.closeTrigger, navigation = _a.navigation, backgroundWrap = _a.backgroundWrap, searchTrigger = _a.searchTrigger;
    openTrigger.addEventListener('click', function () { return handleOpenNavigation(navigation, openTrigger, closeTrigger, backgroundWrap, searchTrigger); });
    closeTrigger.addEventListener('click', function () { return handleCloseNavigation(navigation, openTrigger, closeTrigger, backgroundWrap, searchTrigger); });
};
var tabContext = function (mobileNavigation) {
    if (window.innerWidth > 768)
        return;
    var firstTabElement = mobileNavigation.querySelector('[data-first-focusable]');
    var lastTabElement = mobileNavigation.querySelector('[data-last-focusable]');
    lastTabElement.addEventListener('keydown', function (Event) {
        var key = Event.key;
        if (key === 'Tab')
            firstTabElement.focus();
    });
};
var handleNavigation = function (mobileNavigation) {
    var openTrigger = mobileNavigation.querySelector('[data-open-navigation]');
    var closeTrigger = mobileNavigation.querySelector('[data-close-navigation]');
    var navigation = mobileNavigation.querySelector('[data-navigation]');
    var backgroundWrap = mobileNavigation.querySelector('.extended-fullheight');
    var searchTrigger = mobileNavigation.querySelector('[data-toggle-search]');
    var subParent = Array.from(mobileNavigation.querySelectorAll('[data-navigation-item-firstlevel]'));
    subParent.map(function (x) { return SubNavigationHandler(x, mobileNavigation); });
    tabContext(mobileNavigation);
    window.addEventListener('resize', function () { return tabContext(mobileNavigation); });
    toggleNavigationEvent({
        mobileNavigation: mobileNavigation,
        openTrigger: openTrigger,
        closeTrigger: closeTrigger,
        navigation: navigation,
        backgroundWrap: backgroundWrap,
        searchTrigger: searchTrigger
    });
    return [
        mobileNavigation,
        openTrigger,
        closeTrigger,
        navigation,
        backgroundWrap,
        searchTrigger
    ];
};
var executeNavigationToggle = function () {
    var mobileNavigations = Array.from(document.querySelectorAll('[data-mobile-include]'));
    if (mobileNavigations.length <= 0)
        return;
    mobileNavigations.map(function (mobileNavigation) { return handleNavigation(mobileNavigation); });
};
executeNavigationToggle();
